module.exports = __webpack_public_path__ + "static/media/logo-instagram.b50a839b.png";